import React, { useState, useRef, useEffect } from 'react';
import { Document, Page } from 'react-pdf';
import { Spin } from 'antd';
import styles from "./pdf-viewer.module.css";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

const PDFViewer = ({ url }) => {
  const [numPages, setNumPages] = useState(null);
  const [width, setWidth] = useState(0);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const observer = new ResizeObserver(entries => {
      const newWidth = entries[0].contentRect.width;
      setWidth(newWidth);
    });
    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  const normalizedUrl = (() => {
    try {
      return new URL(url, window.location.origin).href;
    } catch {
      return url;
    }
  })();

  return (
    <div ref={containerRef} style={{ width: '100%' }}>
      <Document
        file={normalizedUrl}
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
        onLoadError={(err) => console.error('onLoadError', err)}
        onSourceError={(err) => console.error('onSourceError', err)}
        loading={
          <div style={{ textAlign: "center", padding: 20 }}>
            <Spin spinning />
          </div>
        }
      >
        {Array.from(new Array(numPages || 0), (_, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            width={width || undefined}
            renderTextLayer
            renderAnnotationLayer
            renderMode="canvas"
            scale={1}
            className={styles["pdf-pages"]}
          />
        ))}
      </Document>
    </div>
  );
};

export default PDFViewer;